import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AutenticadorComponent } from './autenticador/autenticador.component';

/*
  Esta solução de angular integrado com o springboot só funciona com esta rota padrão, outras rotas são ignoradas
*/

const routes: Routes = [{ path: "", component: AutenticadorComponent }];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
